import { Component, OnInit, OnDestroy } from '@angular/core';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import {ActivatedRoute, Router} from "@angular/router";
import {QuickbookService} from "src/app/_services/quickbook.service";
import { ErrorUtil } from "src/app/_utilities/error";
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-quickbook-connection-status',
  standalone: false,
  templateUrl: './quickbook-connection-status.component.html',
  styles: ``
})
export class QuickbookConnectionStatusComponent extends SubscriptionUtil implements OnInit, OnDestroy {
 time : any = 5;
 translate: any;


 constructor(
   private languageTranslateService: LanguageTranslateService, private route: ActivatedRoute,
   private quickBookService: QuickbookService, private errorUtil: ErrorUtil, private router: Router,
   private spinner: NgxSpinnerService
 ) {
    super();
 }


 ngOnInit() {
  this.getLanguageData();
  this.route.queryParamMap.subscribe(params => {
    const code:any  = params.get('code');
    const realmId:any = params.get('realmId');
    const state:any = params.get('state');
    console.log(code, realmId, state, 'code printing..');
    this.sendDataToFieldEx(code, realmId, state)
  });
 }


 getLanguageData() {
   this.push(this.languageTranslateService.wordSrc$.subscribe(data => {
     if(Object.keys(data).length != 0){
       this.translate = data
       console.log("translate",this.translate)
     }
   }))
 }

  push(obs: any) {
   super.push(obs);
  }

  sendDataToFieldEx(code: string, realmId: string, state: string){
    this.spinner.show();
    this.quickBookService.verifyConnection(code, realmId, state).subscribe((res) => {
      this.spinner.hide();
      console.log('res printing from quickbook verify connection api', res)
      if (res.status === 200 || res.status === 201){
        console.log(res, 'verification completed..', res)
        const data = { isVerified: true };
        console.log('window.location.origin printing', window.location.origin);
        if (window.opener) {
          window.opener.postMessage(data, window.location.origin);
        }

        window.close();
      }
      else{
        this.errorUtil.setErrorMessage(
          res.status,
          "Connection to QuickBooks failed. Please try again",
          null,
          "error",
          2000
        );
      }
    }, 
    (err: any) =>{
      this.spinner.hide();
      console.log('err printing from quickbook verify connection api', err)
      this.errorUtil.setErrorMessage(
        err.status,
        err.error ? err.error.message : null,
        err.error ? err.error.message : null,
        "error",
        2000
      );
    })

  }
}

